(ns common.db.effects.query
  (:require [cljs-bean.core :refer [->js]]
            [common.queries :refer [query-client]]
            [re-frame.core :as rf]))

;; Supports either
;; [:invalidate-queries {:queryKey ...}] or
;; [:invalidate-queries [{:queryKey ...} {...options...}]]
;; Both parameters are converted to JS objects with cljs-bean,
;; you can also just provide the JS objects directly.
(rf/reg-fx :invalidate-queries
  (fn [filters-or-args]
    (if (sequential? filters-or-args)
      (let [[filters options] filters-or-args]
        (.invalidateQueries query-client (->js filters) (->js options)))
      (.invalidateQueries query-client (->js filters-or-args)))))

(rf/reg-event-fx :invalidate-queries-event
  (fn [_ [_ payload]]
    {:fx [[:invalidate-queries payload]]}))

;; NOTE: We can also expose more methods when needed:
;; refetchQueries
;; cancelQueries
;; resetQueries
;; and others
